import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Icons from "../../icon";
import ListTab from "../../common/list-tab/list-tab.component";
import { REQUEST_SUB_LINKS as RequestLinks, USER_ROLES_ID as UserRoles } from "../../../constants/external-constants";
import { validateAccessModule } from "../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../utils/rbac-constants.utils";
import FilterButton from "../../common/filter-button/filter-button.component";
import Translation from "../../common/translation/translation.component";
import { requestLogActions } from "./../../../store/external/request-reducer/request-log.reducer";

class RequestHeaderTab extends Component {
    constructor(props) {
        super();
        this.state = {
            searchValue: ""
            , buttonFilterValue: ""
            , tableTabs: []
            , tableLength: 0
            , showApproval: false
            , enableSearchBox: false,
        }
    }

    componentWillMount() {
        this.setTableTabs();
    }

    fetchFilterData = (filter) => {
        console.log("fetch filter")
        this.props.fetchFilterData(filter);
    }

    setSearchValue = (e) => {
        this.setState({ searchValue: e.target.value });
    }

    searchFilterData = (e, filterType) => {
        this.setState({ buttonFilterValue: e.currentTarget.dataset.value });
        this.props.setRequestSearchValue(e.currentTarget.dataset.id, true, filterType);
        this.props.fetchRequestLogItems();
    }

    clearSearhValue = ()=>{
        this.setState({ buttonFilterValue: "" });
        this.props.setRequestSearchValue("", false, null);
        this.props.fetchRequestLogItems();
    }

    setTableLength = (value) => {
        this.setState({tableLength: value})
    }
    setTableTabs = () => {
        const externalDealName = "/external/" + sessionStorage.getItem('DealName') + "/";
        const roleId = parseInt(sessionStorage.getItem('UserRoleID'));
        let showAllRequest = roleId === UserRoles.manager || roleId === UserRoles.teamLead || roleId === UserRoles.lineManager || JSON.parse(sessionStorage.getItem('IsWireLineApprover')) || JSON.parse(sessionStorage.getItem('IsCostCodeAuthorizer')) || JSON.parse(sessionStorage.getItem('IsHRLineManager')) || roleId === UserRoles.admin || roleId === UserRoles.supportAdmin
            || !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.RequestsAllRequestsR, ACCESS_MODULE.RequestsAllRequestsRE, ACCESS_MODULE.RequestsAllRequestsRW]);
        let showApproval = roleId === UserRoles.manager || roleId === UserRoles.teamLead || roleId === UserRoles.lineManager || JSON.parse(sessionStorage.getItem('IsWireLineApprover')) || JSON.parse(sessionStorage.getItem('IsCostCodeAuthorizer')) || JSON.parse(sessionStorage.getItem('IsHRLineManager')) || roleId === UserRoles.admin || roleId === UserRoles.supportAdmin
            || !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.RequestsForApprovalR, ACCESS_MODULE.RequestsForApprovalRE, ACCESS_MODULE.RequestsForApprovalRW]);
        let showCoverage = JSON.parse(sessionStorage.getItem('IsCSM')) || JSON.parse(sessionStorage.getItem('IsRSO')) || JSON.parse(sessionStorage.getItem('IsKeyUser'));
        let showQuotation = JSON.parse(sessionStorage.getItem('IsEnabledQuotationRequest'));

        let tableTabs = [];

        if (showAllRequest) {
            tableTabs.push({
                listTitle: <Translation translationKey="all_request" />
                , href: externalDealName + RequestLinks.allRequest.link
            });

        }

        tableTabs.push({
            listTitle: <Translation translationKey="my_request" />
            , href: externalDealName + RequestLinks.orderRequest.link
        });

        if (showApproval) {

            tableTabs.push({
                listTitle: <Translation translationKey="for_approval" />
                , href: externalDealName + RequestLinks.approvalRequest.link
            });
        }

        if (showCoverage) {

            tableTabs.push({
                listTitle: <Translation translationKey="my_coverage" />
                , href: externalDealName + RequestLinks.coverageRequest.link
            });
        }

        if (showQuotation) {

            tableTabs.push({
                listTitle: <Translation translationKey="quotation_requests" />
                , href: externalDealName + RequestLinks.quotationRequest.link
            });
        }

        this.setState({
            tableTabs: tableTabs
            , showApproval: showApproval       
        });
    }
    render() {
        const { orderFilterData, navMenu } = this.props;

        const filerCheckboxSub = [
            {
                key: 31,
                value: "Change Location Address"
            },
            { key: 5, value: "Change Price Plan" },
            { key: 4, value: "Change User" },
            { key: 14, value: "Change Vendor" },
            { key: 29, value: "Change Vendor" },
            { key: 27, value: "New Circuit" },
            { key: 9, value: "New Mobile Subscription" },
            { key: 32, value: "Other" }];

        const filterData = [
            { id: 1, filterTitle: "Request", subFilterTitles: ["Other"] }
            , { id: 2, filterTitle: "Owner", subFilterTitles: [] }
            , { id: 3, filterTitle: "Status", subFilterTitles: [] }]

        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyRequestsRW]);

        return (
            <div>
                <div className="request-header-container">
                    <div className="request-header-tab">
                    {this.state.showApproval && navMenu?.newNavItems[1]?.NotifApprovalCount > 0 &&
                            < div className="request-approval2">
                            <h1 className="request-approval2-label">{navMenu?.newNavItems[1]?.NotifApprovalCount}</h1>
                        </div>
                        }
                        <ListTab containerClassName="tab-container" tabList={this.state.tableTabs} />
                    </div>
                </div>
            </div >
        );
    }
}

export default connect(
    state => {
        const { requestLog, navMenu } = state;
        return {
            ...requestLog
            , navMenu
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions),
            dispatch
        )
)(RequestHeaderTab);
